module.exports = __webpack_public_path__ + "static/img/zhxiu.8a9d704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhxiu.png
// module id = 517
// module chunks = 1